import {
  EventPhoto,
  IPhotoSectionError,
  PhotoSection,
} from '@src/types/images';
import { photoSectionIdHasError } from '@context/inspections';

export const keepOrderPhotos = (
  currentList: EventPhoto[],
  newList: EventPhoto[],
  sectionsWithError?: IPhotoSectionError[],
): EventPhoto[] => {
  const orderPhotos: EventPhoto[] = [];
  if (!sectionsWithError || sectionsWithError?.length === 0) {
    //Validate if there are photos with errors
    const photoSectionWithErrors: IPhotoSectionError[] = JSON.parse(
      sessionStorage.getItem('photoSectionWithErrors') ?? '[]',
    );
    if (photoSectionWithErrors.length > 0) {
      sectionsWithError = photoSectionWithErrors;
    }
  }

  //Keep the order of the photos
  currentList.forEach((cPhoto: EventPhoto) => {
    if (cPhoto.awsUrl) {
      const urlToSearch =
        cPhoto.awsUrl?.indexOf('?') > 0
          ? cPhoto.awsUrl.split('?')[0]
          : cPhoto.awsUrl;
      const findPhoto = newList?.find(
        (f) => f.awsUrl != null && f.awsUrl?.indexOf(urlToSearch) > -1,
      );
      if (findPhoto != null) {
        orderPhotos.push(findPhoto);
      }
    }
  });

  newList.forEach((nPhoto: EventPhoto) => {
    if (nPhoto.awsUrl) {
      //Detect if the photo section has errors
      const hasError = photoSectionIdHasError(
        sectionsWithError ?? [],
        nPhoto.section as PhotoSection,
      );
      nPhoto.hasError = hasError;

      const urlToSearch =
        nPhoto.awsUrl?.indexOf('?') > 0
          ? nPhoto.awsUrl.split('?')[0]
          : nPhoto.awsUrl;
      const findPhoto = currentList?.find(
        (f) => f.awsUrl != null && f.awsUrl?.indexOf(urlToSearch) > -1,
      );
      if (findPhoto == null) {
        orderPhotos.push(nPhoto);
      }
    } else {
      orderPhotos.push(nPhoto);
    }
  });

  return orderPhotos;
};
